import { Box } from '@hover/blueprint';
import React from 'react';
import { useLocation } from 'react-router';

import {
  CanonicalLink as MetaCanonicalLink,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { TwoColumn } from 'src/shared/layouts';
import { Route as Routes } from 'src/shared/route';

import { OrganizationForm } from './Form';

const Organization = () => {
  const t = useTranslate(TranslationNamespace.SIGN_UP);
  const { pathname } = useLocation();

  return (
    <>
      <MetaCanonicalLink pathname={Routes.SIGN_UP_PROFESSIONAL.path} />
      <MetaTitle
        title={
          pathname === Routes.SIGN_UP_INSURANCE_ORGANIZATION.path
            ? t('insurance.createAnInsuranceAccount')
            : t('professional.createAProfessionalAccount')
        }
      />
      <Box alignItems="center" flexDirection="column" position="relative">
        <TwoColumn.Header
          heading={t('completeYourProfile')}
          subheading={t('finalizeYourAccount')}
        />
        <TwoColumn.Main>
          <OrganizationForm />
        </TwoColumn.Main>
      </Box>
    </>
  );
};

export { Organization };
